export default "/images/41408c4f4e403423ec8b10880dfd5e22.avif";